class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopHoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.desktopMenuOpenClass = 'bl-mega-menu-open';
    this.closeTimeout = null;
    this.onMouseEnter = this.handleMouseEnter.bind(this);
    this.onMouseLeave = this.handleMouseLeave.bind(this);
    this.onSummaryClick = this.handleSummaryClick.bind(this);
    this.onDesktopHoverChange = this.handleDesktopHoverChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.summary.addEventListener('click', this.onSummaryClick);
    this.desktopHoverMediaQuery.addEventListener('change', this.onDesktopHoverChange);
  }

  disconnectedCallback() {
    window.clearTimeout(this.closeTimeout);
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.summary.removeEventListener('click', this.onSummaryClick);
    this.desktopHoverMediaQuery.removeEventListener('change', this.onDesktopHoverChange);
    this.updateDesktopOverlayState();
  }

  isDesktopHoverMenu() {
    return this.desktopHoverMediaQuery.matches;
  }

  handleMouseEnter() {
    if (!this.isDesktopHoverMenu()) return;
    window.clearTimeout(this.closeTimeout);
    this.closeSiblingMenus();
    this.open();
  }

  handleMouseLeave() {
    if (!this.isDesktopHoverMenu()) return;
    window.clearTimeout(this.closeTimeout);
    this.closeTimeout = window.setTimeout(() => {
      this.close();
    }, 300);
  }

  handleSummaryClick(event) {
    // Keep keyboard activation intact, but avoid click-to-toggle on hover-capable desktops.
    if (!this.isDesktopHoverMenu() || event.detail === 0) return;
    event.preventDefault();
  }

  handleDesktopHoverChange() {
    if (!this.isDesktopHoverMenu() && this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    }

    this.updateDesktopOverlayState();
  }

  open() {
    window.clearTimeout(this.closeTimeout);
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    window.clearTimeout(this.closeTimeout);
    super.close();
  }

  closeSiblingMenus() {
    const menuContainer = this.closest('.header__inline-menu');
    if (!menuContainer) return;

    menuContainer.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
  }

  updateDesktopOverlayState() {
    const hasOpenDesktopMegaMenu =
      this.isDesktopHoverMenu() && Boolean(document.querySelector('.header__inline-menu .mega-menu[open]'));

    document.body.classList.toggle(this.desktopMenuOpenClass, hasOpenDesktopMegaMenu);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
    this.updateDesktopOverlayState();
  }
}

customElements.define('header-menu', HeaderMenu);
